// Third party
import axios from 'axios';

// Components
import { getAuthHeaders } from '../utils';
import { DEV_APP_API_URL } from '../constants';
import { TCreateVcatKitReq, TUpdateVcatKitReq } from '../types/requests';

export function VcatKitsController() {
  const getVcatKist = async <T>(): Promise<T> => {
    return await axios.get(`${DEV_APP_API_URL}/vcat-kit/`, {
      headers: getAuthHeaders(),
    });
  };

  const createVcatKit = async <T>(kitData: TCreateVcatKitReq): Promise<T> => {
    return await axios.post(`${DEV_APP_API_URL}/vcat-kit/`, kitData, {
      headers: getAuthHeaders(),
    });
  };

  const updateVcatKit = async <T>(kitId: number, updatedData: TUpdateVcatKitReq): Promise<T> => {
    return await axios.put(`${DEV_APP_API_URL}/vcat-kit/${kitId}`, updatedData, {
      headers: getAuthHeaders(),
    });
  };

  const deleteVcatKit = async <T>(kitId: number): Promise<T> => {
    return await axios.delete(`${DEV_APP_API_URL}/vcat-kit/${kitId}`, {
      headers: getAuthHeaders(),
    });
  };

  return { getVcatKist, createVcatKit, updateVcatKit, deleteVcatKit };
}
